import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-key",
  templateUrl: "./med-icon-key.component.html",
})
export class MedIconKeyComponent extends SvgMixinComponent {}
